import type { TThrownError } from '@/services/errors';

const toFailureKey = (error: Error | null | undefined): string | undefined => {
  if (!error) {
    return undefined;
  }

  return (error as TThrownError).reason ?? error.message;
};

export {
  toFailureKey,
};
